import { render, staticRenderFns } from "./ArchiveReports.vue?vue&type=template&id=fed01b98&scoped=true"
import script from "./ArchiveReports.vue?vue&type=script&lang=js"
export * from "./ArchiveReports.vue?vue&type=script&lang=js"
import style0 from "./ArchiveReports.vue?vue&type=style&index=0&id=fed01b98&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fed01b98",
  null
  
)

export default component.exports